import memoize from 'hs-lodash/memoize';
// @ts-expect-error untyped import
import Url from 'PatternValidationJS/patterns/Url';
export const isValidUrlWithProtocol = memoize(url => {
  return Url.test(url, {
    requireProtocol: true
  });
});